<template>
  <section class="section">
    <div class="container">
      <ValidationObserver ref="executionObserver">
        <p class="title is-6">Información Binomio</p>
        <b-field grouped>
          <b-field expanded>
            <ValidationProvider name="Jinete" :rules="'required'" v-slot="{ errors }">
              <b-field label="Jinete" label-position="inside" :type="{ 'is-danger': errors[0] }" :message="errors">
                <b-autocomplete
                    v-model="rider"
                    placeholder="Selecciona un Jinete"
                    :open-on-focus="true"
                    :data="filterRiders"
                    field="name"
                    @select="option => selectedRider = option" :loading="isLoadingRiders"
                    :custom-formatter="fullName">
                    <template slot-scope="props">
                      {{props.option.lastname}} {{props.option.name}}
                    </template>
                </b-autocomplete>
              </b-field>
            </ValidationProvider>
          </b-field>
          <b-field expanded>
            <ValidationProvider name="Caballo" :rules="'required'" v-slot="{ errors }">
              <b-field label="Caballo" label-position="inside" :type="{ 'is-danger': errors[0] }" :message="errors">
                <b-autocomplete
                  v-model="horse"
                  placeholder="Selecciona un Caballo"
                  :open-on-focus="true"
                  :data="filterHorses"
                  field="name"
                  @select="option => selectedHorse = option"
                  :loading="isLoadingHorses" expanded>
                  <template slot-scope="props">
                        <div class="media">
                            <div class="media-content">
                                <b>{{ props.option.name }}
                                  <b-icon icon="star" size="is-small"  v-if="selectedRider && props.option.rider_id === selectedRider.id"></b-icon>
                                </b>
                            </div>
                        </div>
                    </template>
                </b-autocomplete>
              </b-field>
            </ValidationProvider>
          </b-field>
        </b-field>
        <b-field grouped>
          <b-field>
            <ValidationProvider name="Salida" :rules="'required'" v-slot="{ errors }">
              <b-field label="Salida" label-position="inside" :type="{ 'is-danger': errors[0] }" :message="errors">
                <!-- <b-select placeholder="Selecciona un salida" v-model="execution.start_estimated" expanded>
                  <option
                      v-for="position in positions"
                      :value="position.hour"
                      :key="position.id">
                      {{ `${position.hour}` }}
                  </option>
              </b-select> -->
              <b-timepicker icon="clock" editable v-model="startEstimated"></b-timepicker>
              <div class="control">
                <b-button icon-left="minus" @click="subtractMinutes"/>
                <b-button icon-left="plus" class="btn-right" @click="addMinutes"/>
              </div>
              </b-field>
            </ValidationProvider>
          </b-field>
          <b-field v-if="execution.execution_status_id === 1" expanded>
            <ValidationProvider name="Lección" :rules="'required'" v-slot="{ errors }">
              <b-field label="Lección" label-position="inside" :type="{ 'is-danger': errors[0] }" :message="errors">
                <b-select  v-model="execution.lesson_id" placeholder="Selecciona una lección" expanded :loading="isLoadingLessons">
                  <optgroup v-for="level in levels" :label="level.name" :key="`level-${level.id}`">
                      <option
                        v-for="lesson in level.lessons"
                        :value="lesson.id"
                        :key="`lesson-${lesson.id}`">
                        {{ lesson.name }}
                      </option>
                  </optgroup>
                </b-select>
              </b-field>
            </ValidationProvider>
          </b-field>
        </b-field>
      </ValidationObserver>
      <div>
        <p class="title is-6">Evaluadores</p>
        <judges-execution-table :rider-id="riderId" :judges-execution-list.sync="judgesExecution" :deleted-judges.sync="deletedJudges" :execution="execution" :execution-id="executionId"/>
      </div>
      <br>
      <div class="columns">
        <div class="column is-6">
          <b-field>
            <b-button type="is-default" @click="cancel" expanded>Cancelar</b-button>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field>
            <b-button type="is-primary" @click="save" expanded>Guardar</b-button>
          </b-field>
        </div>
      </div>
    </div>
    <b-loading :active.sync="isLoading"></b-loading>
  </section>
</template>

<script>
import LevelService from '@/services/LevelService'
import HorseService from '@/services/HorseService'
import RiderService from '@/services/RiderService'
import ExecutionService from '@/services/ExecutionService'
import CredentialsService from '@/services/CredentialsService'

import JudgesExecutionTable from './JudgesExecutionTable'
const Diacritics = require('diacritic')

export default {
  props: {
    event: {
      required: true,
      type: Object
    },
    executionId: {
      required: false,
      default: null
    },
    lastTime: {
      type: String,
      default: null
    }
  },
  components: {
    JudgesExecutionTable
  },
  created () {
    this.getHorses()
    this.getLevelsWithLessons()
    this.getRiders()
    this.execution.user_id = this.userId
    this.execution.date_estimated = this.event ? this.$moment(this.event.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD') : null
    this.execution.tenant_id = this.tenantId
    if (this.executionId) {
      this.getExecution()
    } else {
      this.startEstimated = this.lastTime ? this.$moment(this.lastTime, 'HH:mm').add(this.intervalPositions, 'm').toDate() : null
    }
  },
  data () {
    return {
      judgesExecution: [],
      deletedJudges: [],
      rider: '',
      horse: '',
      isLoading: false,
      selectedHorse: null,
      selectedRider: null,
      levels: [],
      horses: [],
      riders: [],
      isLoadingHorses: false,
      isLoadingRiders: false,
      isLoadingLessons: false,
      execution: {
        lesson_id: null,
        rider_id: null,
        horse_id: null,
        club_id: 1,
        user_id: null,
        status_id: 1,
        date_estimated: null,
        start_estimated: null,
        execution_status_id: 1,
        tenant_id: null
      },
      intervalPositions: 15,
      limitTime: '22:00',
      startTime: '08:00',
      startEstimated: null
    }
  },
  methods: {
    subtractMinutes () {
      this.startEstimated = this.$moment(this.startEstimated, 'HH:mm').subtract(1, 'm').toDate()
    },
    addMinutes () {
      this.startEstimated = this.$moment(this.startEstimated, 'HH:mm').add(1, 'm').toDate()
    },
    resetData () {
      this.selectedHorse = null
      this.selectedRider = null
      this.judgesExecution = []
      this.rider = ''
      this.horse = ''
      this.execution = {
        lesson_id: null,
        rider_id: null,
        horse_id: null,
        club_id: 1,
        user_id: this.userId,
        status_id: 1,
        date_estimated: this.event ? this.$moment(this.event.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD') : null,
        tenant_id: this.tenantId,
        start_estimated: null,
        execution_status_id: 1
      }
      this.startEstimated = this.currenTime
    },
    async getExecution () {
      if (this.executionId) {
        this.isLoading = true
        let response = await ExecutionService.getExecution(this.event.id, this.executionId)
        this.execution = response.data.data
        this.selectedHorse = this.execution.horse
        this.selectedRider = this.execution.rider
        this.rider = this.fullName(this.selectedRider)
        this.horse = this.selectedHorse.name
        this.execution.date_estimated = this.execution ? this.$moment(this.execution.date_estimated, 'DD-MM-YYYY').format('YYYY-MM-DD') : null
        this.startEstimated = this.$moment(this.execution.start_estimated, 'HH:mm').toDate()
        this.judgesExecution = this.execution.judges_executions.map((judgeExecution) => {
          let judge = judgeExecution.judge
          let secretary = judgeExecution.secretary
          return {
            'id': judgeExecution.id,
            'judge_id': judge.id,
            'judge_fullname': this.fullName(judge),
            'secretary_id': secretary ? secretary.id : null,
            'secretary_fullname': secretary ? this.fullName(secretary) : null,
            'order': judgeExecution.order,
            'position': judgeExecution.position,
            'new': false,
            'deleted': false
          }
        })
        this.isLoading = false
      }
    },
    async deleteJudgeExecution (executionId, judgeExecutionId) {
      let response = await ExecutionService.deleteJudgeExecution(executionId, judgeExecutionId)
      return response.data.data
    },
    cancel () {
      this.resetData()
      this.$refs.executionObserver.reset()
      this.$nextTick(() => {
        this.$emit('update:executionId', null)
        this.$emit('saved')
      })
    },
    async save () {
      if (await this.$refs.executionObserver.validate()) {
        this.isLoading = true

        let execution

        if (this.executionId) {
          for (let index = 0; index < this.deletedJudges.length; index++) {
            let judgeExecution = this.deletedJudges[index]
            await ExecutionService.deleteJudgeExecution(this.executionId, judgeExecution.id)
          }

          const editExecutionPromises = this.filterEditedJudgesExecution.map((judgeExecution) => {
            return ExecutionService.updateJudgeExecution(this.executionId, judgeExecution.id, judgeExecution);
          });

          await Promise.all(editExecutionPromises);

          let response = await ExecutionService.updateExecution(this.event.id, this.executionId, this.execution)
          execution = response.data.data
        } else {
          let response = await ExecutionService.createExecution(this.event.id, this.execution)
          execution = response.data.data
        }
        await ExecutionService.createJudgeExecutionList(execution.id, {
          judges: this.filterJudgesExecution
        })

        this.resetData()
        this.isLoading = false
        this.$refs.executionObserver.reset()
        this.$nextTick(() => {
          this.$emit('update:executionId', null)
          this.$emit('saved')
        })
      }
    },
    async getLevelsWithLessons () {
      this.isLoadingLessons = true
      let response = await LevelService.getLevels()
      this.levels = response.data.data
      for (let i = 0; i < this.levels.length; i++) {
        var lessons = this.levels[i].lessons
        this.levels[i].lessons = lessons.sort((a, b) => {
          if (a.name > b.name) {
            return 1
          }
          if (a.name < b.name) {
            return -1
          }
          return 0
        })
      }
      this.value = this.selected
      this.isLoadingLessons = false
    },
    async getHorses () {
      this.isLoadingHorses = true
      let params = {
        'include[0]': 'rider',
        'active': true
      }
      let response = await HorseService.getHorses(params)
      this.horses = response.data.data
      this.isLoadingHorses = false
    },
    async getRiders () {
      this.isLoadingRiders = true
      let params = {
        'user_status_id': 1
      }
      let response = await RiderService.getRiders(params)
      this.riders = response.data.data
      this.isLoadingRiders = false
    },
    fullName (object) {
      return `${object.lastname} ${object.name}`
    }
  },
  computed: {
    filterJudgesExecution () {
      return this.judgesExecution.filter((x) => x.new === true && x.deleted === false)
    },
    filterEditedJudgesExecution () {
      return this.judgesExecution.filter((x) => x.edited === true && x.deleted === false)
    },
    filterHorses () {
      let fixedHorses = Array.from(this.horses)
      fixedHorses.forEach((horse) => {
        horse.fixed = Diacritics.clean(horse.name)
      })

      return fixedHorses.filter((horse) => {
        return horse.fixed
          .toString()
          .toLowerCase()
          .indexOf(Diacritics.clean(this.horse.toLowerCase())) >= 0
      }).sort((a, b) => {
        if (this.selectedRider && a.rider_id === this.selectedRider.id) return -1
        return 0
      })
    },
    filterRiders () {
      let fixedData = Array.from(this.riders)
      fixedData.forEach((rider) => {
        rider.fixed = Diacritics.clean(`${rider.lastname} ${rider.name}`.toString().toLowerCase())
      })

      return fixedData.filter((rider) => {
        let likeSearch = rider.fixed.indexOf(this.rider.toLowerCase()) >= 0
        let notJudge = this.judgesExecution.findIndex((x) => {
          return (rider.id === x.judge_id || rider.id === x.secretary_id) && (x.deleted !== true)
        }) === -1
        return likeSearch && notJudge
      })
    },
    positions () {
      let date = this.event ? this.$moment(this.event.start_at, 'HH:mm') : this.$moment(this.startTime, 'HH:mm')
      let limit = this.$moment(this.limitTime, 'HH:mm')
      let positions = []
      let interval = this.intervalPositions
      let index = 0
      while (date.isSameOrBefore(limit)) {
        let hour = date.format('HH:mm')
        positions.push({
          id: index + 1,
          hour: hour
        })
        date.add(interval, 'm')
        index++
      }

      return positions
    },
    riderId () {
      return this.selectedRider ? this.selectedRider.id : null
    },
    userId () {
      return CredentialsService.getUser().id
    },
    tenantId () {
      return CredentialsService.getCurrentTenantId()
    },
    currenTime () {
      if (this.lastTime && !this.executionId) {
        return this.$moment(this.lastTime, 'HH:mm').add(this.intervalPositions, 'm').toDate()
      } else {
        return this.$moment(this.startTime, 'HH:mm').add(this.intervalPositions, 'm').toDate()
      }
    }
  },
  watch: {
    startEstimated: {
      immediate: true,
      handler: function(value) {
        if (value) {
          this.execution.start_estimated = this.$moment(value, 'HH:mm').format('HH:mm')
        } else {
          this.execution.start_estimated =  null
        }
      }
    },
    selectedRider (newValue, oldValue) {
      if (oldValue && !newValue) {
        this.rider = ''
        return
      }
      this.execution.rider_id = newValue.id
    },
    selectedHorse (newValue, oldValue) {
      if (oldValue && !newValue) {
        this.horse = ''
        return
      }
      this.execution.horse_id = newValue.id
    },
    event (value) {
      if (value) {
        this.startEstimated = this.$moment(value.start_date, 'HH:mm').toDate()
      } else {
        this.startEstimated = null
      }
    },
    executionId (value) {
      if (value) {
        this.getExecution()
      }
    },
    lastTime (value) {
      if (value && !this.executionId) {
        this.startEstimated = this.$moment(value, 'HH:mm').add(this.intervalPositions, 'm').toDate()
      }
    }
  }
}
</script>
